export const LOAD_INSTRUMENTS_REQUESTED = 'LOAD_INSTRUMENTS_REQUESTED';
export const LOAD_INSTRUMENTS_SUCCEEDED = 'LOAD_INSTRUMENTS_SUCCEEDED';
export const LOAD_INSTRUMENTS_FAILED = 'LOAD_INSTRUMENTS_FAILED';

export const DELETE_INSTRUMENT_REQUESTED = 'DELETE_INSTRUMENT_REQUESTED';
export const DELETE_INSTRUMENT_SUCCEEDED = 'DELETE_INSTRUMENT_SUCCEEDED';
export const DELETE_INSTRUMENT_FAILED = 'DELETE_INSTRUMENT_FAILED';
